define('v3/Common/Services/Frontend/Pupils.Service',[
	'jquery',
	'lodash',
	'v3/Common/Services/Backend/pupilBackend',
	'env',
	'v3/Common/Services/urlService'
], function ($, _, pupilBackend, env, urlService) {
	function PupilsService () {
		var self = this;
		var loadedPupils = null;
		var workingPromise = null;
		self.getPupil = function (pupilId) {
			var promise = $.Deferred();
			var resolve = function () {
				var pup = loadedPupils[pupilId];
				var pupilData = pup || { firstName: '???', suffix: '', lastName: '???', shortName: '???', longName: '???' };
				promise.resolve(pupilData);
			};
			if (loadedPupils) {
				resolve();
			} else {
				self.getPupils().done(resolve);
			}
			return promise;
		};

		self.getPupils = function () {
			var promise = $.Deferred();
			if (loadedPupils) {
				promise.resolve(loadedPupils);
			} else {
				var waitFor = null;
				if (workingPromise) {
					waitFor = workingPromise;
				} else {
					waitFor = pupilBackend.getPupilsLongNamesWithNameForSorting();
					workingPromise = waitFor;
					waitFor.done(function (pupils) {
						loadedPupils = _.zipObject(_.map(pupils, 'pupilId'), pupils);
						workingPromise = null;
					});
				}
				waitFor.done(function () {
					promise.resolve(loadedPupils);
				});
			}
			return promise;
		};

		self.getSubjectGroupPupils = function (subjectGroupId) {
			return pupilBackend.getSubjectGroupPupilNamesForSorting(subjectGroupId);
		};

		self.navigateToReportPage = function (pupilId, subjectGroupId) {
			urlService.pupilReviewPageUrl(subjectGroupId, pupilId).done(function (url) {
				window.location.href = url;
			});
		};
	};

	return new PupilsService();
});

